import React, { useState, useRef, useEffect } from "react"
import { Container, Col, Row, Carousel } from "react-bootstrap"
import "./PropertyCard.scss"
// import ScrollAnimation from "react-animate-on-scroll";
import CardList from "./CardList"
import { Link, hasValidPrice } from "@StarberryUtils";
import YouTube from 'react-youtube';
import Truncate from 'react-truncate';
import SellProduct from "../SellProduct/SellProduct"
import closeIcon from "../../../images/close.png"
import { ShowProcessedImage } from "../../common/ggfx-client/module/components/show-image";
import imageConfig from "../../../../static/images/config.json";
import ImageTransform from "../../common/ggfx-client/module/components/image-transform";
import ImageModule from "../../common/Image_Module";
export const SingleProperty = (props) => {
    const property = CardList[0];
    const [isPlay, setPlay] = useState(false);
    const hit = props.hit;
    const hasBedroomRange = hit?.max_bedrooms && hit.max_bedrooms > hit.bedroom;
    const displayTitle = hasBedroomRange && hit?.title
        ? hit.title.replace(new RegExp(`^${hit.bedroom}\\b`), `${hit.bedroom}-${hit.max_bedrooms}`)
        : hit?.title;
    const rawVirtualTour = hit?.virtual_tour;
    const virtualTourUrl = Array.isArray(rawVirtualTour)
        ? (rawVirtualTour[0] || "")
        : (typeof rawVirtualTour === "string" ? rawVirtualTour : "");

    const getVideoId = (url) => {
        if (!url) return "";
        if (url.includes("embed/")) {
            return url.split("embed/")[1]?.split("?")[0]?.split("&")[0] || "";
        }
        if (url.includes("v=")) {
            return url.split("v=")[1]?.split("&")[0] || "";
        }
        if (url.includes("youtu.be/")) {
            return url.split("youtu.be/")[1]?.split("?")[0]?.split("&")[0] || "";
        }
        return "";
    };
    const videoId = getVideoId(virtualTourUrl);

    const propertyDomId = `prop-card-${hit?.objectID || hit?.id}`;
    return (
        <section id={propertyDomId} className={`property-card ${property?.mainClassName}`}>
            <Container>
                <Row>
                    <Col xl={6}>
                        <div className="product-card-img img-zoom">
                            {
                                props.strapi ?
                                <Carousel className="w-100">
                                    {hit?.images && hit?.images.slice(0, 4).map((img, i) => {
                                        const imageUrl = img?.hd_url || img?.larger_url || img?.srcUrl;
                                        return (
                                            <Carousel.Item key={i} className="w-100 position-relative" id={"prop-img"+i}>
                                                <Link className="w-100" to={`/property-${hit.searchType === "sales" ? "for-sale" : "to-rent"}/${hit.slug}-${hit.id}`} onClick={() => props.onNavigateToProperty(hit)}>
                                                    <img  src={imageUrl}  alt={hit.title || "property image"}  /> 
                                                </Link>
                                            </Carousel.Item>
                                        )}
                                    )}
                                </Carousel> :
                                <Carousel 
  className="w-100" 
  interval={null} 
  controls={Array.isArray(hit?.images) && hit.images.length > 1}
>
                                    {hit?.images &&
                                        hit?.images.slice(0, 4).map((img, k) => (
                                            <Carousel.Item key={k} className="w-100">
                                                <div className="property-slide-image property-item">
                                                    {/* {img.srcUrl && <img src={img.srcUrl.replace("http", "https")} alt="img" />} */}
                                                    <Link className="w-100" to={`/property-${hit.searchType === "sales" ? "for-sale" : "to-rent"}/${hit.slug}-${hit.objectID}`} onClick={() => props.onNavigateToProperty(hit)}>
                                                        <ShowProcessedImage
                                                            images={img}
                                                            transforms={imageConfig.property.images.searchResults.sizes}
                                                        />
                                                    </Link>
                                                </div>
                                            </Carousel.Item>
                                        )
                                    )}
                                </Carousel>
                            }
                            {virtualTourUrl && <div className="product-btn prop-card-play-btn" >
                                <strong className="video-btn" onClick={e => {setPlay(true)}}>
                                <i className="icon-video" onClick={e => setPlay(true)} />
                                </strong>
                            </div>}
                            {(virtualTourUrl && isPlay) && 
                                <div className="video-container">
                                    <YouTube
                                        className="video-inline"
                                        videoId={videoId}
                                        opts={{
                                            height: "100%",
                                            width: "100%",
                                            playerVars: {
                                                autoplay: 1,
                                                disablekb: 1
                                            }
                                        }}
                                        onEnd={() => setPlay(false)}
                                        onError={(err) => {
                                            console.log(err)
                                            setPlay(false)
                                        }}
                                    />
                                    <div className="btn btn-light close-icon" onClick={() => setPlay(false)}>
                                        <img src={closeIcon} alt="close-icon"/>
                                    </div>
                                </div>
                            }
                            <button className="prop-card-btn">{hit.status}</button>
                        </div>
                    </Col>
                    <Col xl={6} className="pr-xl-0">
                        <div className="product-card-details">
                            <h2>
                                <Link
                                    to={`/property-${hit.searchType === "sales" ? "for-sale" : "to-rent"}/${hit.slug}-${props.strapi ? hit.id : hit.objectID}`}
                                    onClick={() => props.onNavigateToProperty(hit)}
                                >
                                    {hit.display_address}
                                </Link>
                            </h2>
                            <span className="sm-content">
                                {displayTitle}
                            </span>
                            {/* <span className="price-list">
                                {hit?.price_qualifier} {hit?.price_qualifier !== "Price on Application" ? "£ " + hit?.price.toLocaleString() : ""} {hit.searchType === "lettings" ? "PCM" : ""}
                            </span> */}
                            <span className="price-list">
                                 {hasValidPrice(hit?.price) ? "£ " + hit?.price.toLocaleString() : (hit?.price_qualifier || "POA")} {hasValidPrice(hit?.price) && hit.searchType === "lettings" ? "PCM" : ""}
                            </span>
                            <div className="product-icon">
                                <span className="details">
                                    <i className="icon-bed-room d-md-none"></i>
                                    <span className="quantity">{hasBedroomRange ? `${hit.bedroom}-${hit.max_bedrooms}` : hit.bedroom}</span>
                                    <span className="title d-none d-md-block">Bedrooms</span>
                                </span>
                                <span className="details">
                                    <i className="icon-bath-room d-md-none"></i>
                                    <span className="quantity">{hit.bathroom}</span>
                                    <span className="title d-none d-md-block">Bathrooms</span>
                                </span>
                                <span className="details rm-border">
                                    <i className="icon-reception d-md-none"></i>
                                    <span className="quantity">{hit.reception}</span>
                                    <span className="title d-none d-md-block">Receptions</span>
                                </span>
                                {/* <span className="sm-text d-none d-md-block">Private Gated Development</span> */}
                            </div>
                            <div>
                                <p>
                                    <Truncate lines={4}>
                                    {hit?.description}
                                    </Truncate>
                                </p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}   

const LISTING_SCROLL_STORAGE_KEY = "bvn_listing_scroll_state";

const PropertyCard = (props) => {
    const { hits,  hasPrevious, refinePrevious, hasMore, refineNext, location } = props;
    const pagesLoaded = useRef(1);
    const restoreState = useRef(undefined);
    const hasCheckedRestore = useRef(false);

    if (!hasCheckedRestore.current && typeof window !== "undefined") {
        hasCheckedRestore.current = true;
        try {
            const saved = JSON.parse(sessionStorage.getItem(LISTING_SCROLL_STORAGE_KEY) || "null");
            if (saved && saved.pathname === window.location.pathname) {
                restoreState.current = saved;
            } else {
                sessionStorage.removeItem(LISTING_SCROLL_STORAGE_KEY);
            }
        } catch (e) {}
    }

    useEffect(() => {
        const target = restoreState.current;
        if (!target) return;
        // wait for the first real batch of cards to render before doing anything
        if (hits.length === 0) return;
        if (pagesLoaded.current < target.pages && hasMore) {
            pagesLoaded.current += 1;
            refineNext();
            return;
        }
        restoreState.current = null;
        try { sessionStorage.removeItem(LISTING_SCROLL_STORAGE_KEY); } catch (e) {}

        // scroll the exact card into view rather than a raw pixel offset, since
        // card heights/image load timing (and browser chrome) differ enough on
        // mobile that a stored scrollY drifts from where the card actually sits
        const scrollToTarget = () => {
            const el = target.propertyId && document.getElementById(`prop-card-${target.propertyId}`);
            if (el) {
                el.scrollIntoView({ block: 'center', behavior: 'auto' });
            } else {
                window.scroll({ top: target.scrollY, behavior: 'auto' });
            }
        };
        // retry a few times as images/lazy content finish loading and shift layout
        // (more pronounced on mobile due to slower loads and single-column stacking)
        const delays = [0, 150, 400, 800, 1500];
        delays.forEach(delay => {
            setTimeout(() => requestAnimationFrame(scrollToTarget), delay);
        });
    }, [hits.length, hasMore]);

    const saveListingState = (hit) => {
        if (typeof window === "undefined") return;
        try {
            sessionStorage.setItem(LISTING_SCROLL_STORAGE_KEY, JSON.stringify({
                pathname: window.location.pathname,
                scrollY: window.scrollY,
                pages: pagesLoaded.current,
                propertyId: hit?.objectID || hit?.id || null
            }));
        } catch (e) {}
    };

    const handleShowMore = () => {
        pagesLoaded.current += 1;
        refineNext();
    };

    return (
        <React.Fragment>
            {hits.map((hit, i) =>
                <React.Fragment key={i}>
                    {(i % 6 == 0 && i !== 0) && <div className="property-card px-lg-3 px-0"><SellProduct title="Are you ready to Sell or Let your property?"  link="book-a-valuation" class="mb-5"/></div>}
                    <SingleProperty hit={hit} key={i} location={location} onNavigateToProperty={saveListingState}/>
                </React.Fragment>
            )}
            {(hits.length > 0 && hasMore) && (
                <Col lg={12} className="d-flex justify-content-center py-5">
                    <button
                        id="mynextbut"
                        onClick={handleShowMore}
                        disabled={!hasMore}
                        className="btn property-search-load-more"
                    >
                        Show more
                    </button>
                </Col>
        )}
        </React.Fragment>
    )
}
export default PropertyCard
